import { RootStore } from 'Portals/Customer/stores'

import { CustomerInvoiceTable } from './CustomerInvoiceTable'

export class CustomerInvoiceStore {
	table: CustomerInvoiceTable

	constructor(private rootStore: RootStore) {
		this.table = new CustomerInvoiceTable(rootStore)
	}
}
